import { FormBase } from 'core/components';

export default class FacilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModalForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'insuranceQuestion',
                    label: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_TEMPLATE_INSURANCE_QUESTION_MODAL.INSURANCE_QUESTION_LABEL',
                    placeholder: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_TEMPLATE_INSURANCE_QUESTION_MODAL.INSURANCE_QUESTION_PLACEHOLDER',
                    rules: 'string'            
                },
            ],
        };
    }
}
